import styled from 'styled-components';
import { themeGet, getPaletteColor } from '@magalu/stereo-ui-styles';
import { typography, space } from 'styled-system';
import { Icon as IconComponent } from '@magalu/stereo-ui-icons';
import { Popper as PopperComponent, Text, Grid, Box, Flex } from '../../../atoms';
export const Popper = styled(PopperComponent).attrs(props => Object.assign({
  backgroundColor: '#fffce6'
}, props))`
  z-index: ${themeGet('zIndices.0')};
`;
export const Title = styled(Text).attrs(props => Object.assign({
  fontSize: 2,
  fontWeight: 'bold',
  lineHeight: 'display',
  mb: 2
}, props))`
  color: ${props => getPaletteColor('primary.dark')(props)};

  ${typography}
`;
export const Content = styled(Text).attrs(props => Object.assign({
  fontSize: 1,
  lineHeight: 'display'
}, props))`
  color: ${props => getPaletteColor('primary.dark')(props)};

  ${typography}
`;
export const Icon = styled(IconComponent).attrs(props => Object.assign({
  fill: 'primary.dark'
}, props))``;
export const ZipCodeBtn = styled(Text).attrs(props => Object.assign({
  fontSize: 2,
  fontWeight: 'bold',
  justifySelf: 'flex-end',
  mb: 2,
  mt: 3,
  mr: 2
}, props))`
  color: ${props => getPaletteColor('primary.dark')(props)};

  cursor: pointer;
`;
export const InfoContainer = styled(Grid).attrs(props => Object.assign({
  pl: 2
}, props))`
  max-width: 364px;
`;
export const SuccessContainer = styled(Flex).attrs(props => Object.assign({
  alignItems: 'center',
  gap: 2,
  px: 2,
  py: 3
}, props))`
  color: ${props => getPaletteColor('primary.dark')(props)};

  max-width: 384px;
`;
export const ClosePopper = styled(Box).attrs(props => Object.assign({
  width: 'fit-content'
}, props))`
  align-self: baseline;
  justify-self: end;
`;
export const ZipcodeContainer = styled.div.attrs(props => Object.assign({
  ml: 1,
  mr: 3
}, props))`
  width: 200px;
  transition: all 0.2s ease-in-out;
  &:hover:not(:disabled) {
    transform: scale(1.1);
  }
  ${space}
`;